module.exports = __webpack_public_path__ + "img/tutor.a09f2af3.svg";